import React, { useState } from "react";
import {
  HiOutlineMegaphone,
  HiOutlineBuildingOffice,
  HiOutlineBuildingOffice2,
  HiOutlineNewspaper,
  HiOutlineReceiptPercent,
  HiOutlineCalendarDays,
  HiOutlineUserGroup,
  HiOutlineUsers,
} from "react-icons/hi2";
import styles from "./menu.module.css";
import { useNavigate } from "react-router-dom";

function Menu({userPermissions}) {

  const navigate = useNavigate();
  const [animation, setAnimation] = useState(false);

  return (
    <div className="body">
      {
        userPermissions ?
          <div className={styles.center}>
            <div
              className={
                animation ? styles.circleContainerReverse : styles.circleContainer
              }
            >
              <div className={styles.bigCircle} style={userPermissions ? {} : {opacity: 0.4}} />
              <div
                onClick={() => {
                  if (userPermissions.eventos){
                    setAnimation(true);
                    setTimeout(() => {
                      navigate("/calendario", {state: { animate: true}});
                    }, 1800);
                  }
                }}
                className={`${styles.circle} ${userPermissions.eventos ? "" : styles.disabledCircle}`}
              >
                <div className={styles.columnCircle}>
                  <HiOutlineCalendarDays size={40} />
                  Agenda
                </div>
              </div>
              <div
                onClick={() => {
                  if (userPermissions.colaboradores || userPermissions.cartoes){
                    setAnimation(true);
                    setTimeout(() => {
                      navigate("/colaboradores", {state: { animate: true}});
                    }, 1800);
                  }
                }}
                className={`${styles.circle} ${userPermissions.colaboradores || userPermissions.cartoes ? "" : styles.disabledCircle}`}
              >
                <div className={styles.columnCircle}>
                  <HiOutlineUserGroup size={40} />
                  Colaboradores
                </div>
              </div>
              <div
                onClick={() => {
                  if (userPermissions.empresas || userPermissions.cartoes){
                    setAnimation(true);
                    setTimeout(() => {
                      navigate("/empresas", {state: { animate: true}});
                    }, 1800);
                  }
                }}
                className={`${styles.circle} ${userPermissions.empresas || userPermissions.cartoes ? "" : styles.disabledCircle}`}
              >
                <div className={styles.columnCircle}>
                  <HiOutlineBuildingOffice size={40} />
                  Empresas
                </div>
              </div>
              <div
                onClick={() => {
                  if (userPermissions.protocolos){
                    setAnimation(true);
                    setTimeout(() => {
                      navigate("/protocolos", {state: { animate: true}});
                    }, 1800);
                  }
                }}
                className={`${styles.circle} ${userPermissions.protocolos ? "" : styles.disabledCircle}`}
              >
                <div className={styles.columnCircle}>
                  <HiOutlineReceiptPercent size={40} />
                  Protocolos
                </div>
              </div>
              <div
                onClick={() => {
                  if (userPermissions.colaboradores){
                    setAnimation(true);
                    setTimeout(() => {
                      navigate("/utilizadores", {state: { animate: true}});
                    }, 1800);
                  }
                }}
                className={`${styles.circle} ${userPermissions.colaboradores ? "" : styles.disabledCircle}`}
              >
                <div className={styles.columnCircle}>
                  <HiOutlineUsers size={40} />
                  Utilizadores
                </div>
              </div>
              <div
                onClick={() => {
                  if (userPermissions.unidades){
                    setAnimation(true);
                    setTimeout(() => {
                      navigate("/unidades", {state: { animate: true}});
                    }, 1800);
                  }
                }}
                className={`${styles.circle} ${userPermissions.unidades ? "" : styles.disabledCircle}`}
              >
                <div className={styles.columnCircle}>
                  <HiOutlineBuildingOffice2 size={40} />
                  Unidades
                </div>
              </div>
              <div
                onClick={() => {
                  if (userPermissions.campanhas){
                    setAnimation(true);
                    setTimeout(() => {
                      navigate("/campanhas", {state: { animate: true}});
                    }, 1800);
                  }
                }}
                className={`${styles.circle} ${userPermissions.campanhas ? "" : styles.disabledCircle}`}
              >
                <div className={styles.columnCircle}>
                  <HiOutlineMegaphone size={40} />
                  Campanhas e Eventos
                </div>
              </div>
              <div
                onClick={() => {
                  if (userPermissions.comunicacoes){
                    setAnimation(true);
                    setTimeout(() => {
                      navigate("/comunicacoes-internas", {state: { animate: true}});
                    }, 1800);
                  }
                }}
                className={`${styles.circle} ${userPermissions.comunicacoes ? "" : styles.disabledCircle}`}
              >
                <div className={styles.columnCircle}>
                  <HiOutlineNewspaper size={40} />
                  Comunicações Internas
                </div>
              </div>
            </div>
          </div>
        :""
      }
    </div>
  );
}

export default Menu;